export default __webpack_public_path__ + "static/media/sandman.723a19a6.mp3";